import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  divider: {
    margin: '28px 0 24px',
  },
  title: {
    fontSize: 16,
  },
  subtitle: {
    fontSize: 14,
  },
  motiveSelect: {
    marginBottom: 8,
  },
  removeAccessDate: {
    fontWeight: 600,
  },
}));
